import { render, staticRenderFns } from "./sesionMenu.vue?vue&type=template&id=e25920aa&"
import script from "./sesionMenu.vue?vue&type=script&lang=js&"
export * from "./sesionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports